import { Link } from "react-router-dom";
import { ShoppingBagIcon } from "@heroicons/react/24/outline";
import { formatPrice } from "@/utils/utils";
import useCart from "@/features/cart/useCart";
import CartErrors from "@/components/features/cart/CartErrors";
import CartItems from "@/components/features/cart/CartItems";
import SpinnerLoading from "@/components/ui/loading/SpinnerLoading";

const Cart = ({
  cart,
  isCartEmpty,
  cartUpdatingStatus,
  isCartUpdating,
  quantityInputs,
  handleQuantityChange,
  handleRemoveCartItem,
}: ReturnType<typeof useCart>) => {
  const { items = [], totals } = cart || {};

  return (
    <>
      {isCartEmpty ? (
        <EmptyCart />
      ) : (
        <>
          {/* Cart Errors */}
          <CartErrors errors={cart?.errors || []} />
          {/* Item List */}
          <CartItems
            items={items}
            updatingStatus={cartUpdatingStatus}
            isUpdating={isCartUpdating}
            quantityControl={{
              quantityInputs,
              handleQuantityChange,
              handleRemoveCartItem,
            }}
            showProductLink={true}
          />

          {/* Cart Summary */}
          <section className="brand-card mt-2 flex-1 border-y">
            <div className="flex justify-between">
              <div className="brand-text-lg">小計</div>
              <div className="brand-text-lg text-right font-bold text-accent">
                {isCartUpdating ? <SpinnerLoading /> : `NT${formatPrice(totals?.total_items ?? 0)}`}
              </div>
            </div>
            <div className="brand-text-sm text-right text-neutral">運費：結帳時計算</div>
          </section>
        </>
      )}
    </>
  );
};

const EmptyCart = () => {
  return (
    <>
      <div className="brand-text-lg flex flex-col items-center justify-center text-center">
        <>
          <ShoppingBagIcon className="box-content size-12 p-2" />
          尚未加入任何商品
        </>
        <Link to={`/shop`}>
          <button className="brand-btn-base btn btn-secondary mt-8 w-full lg:w-fit">
            前往選購
          </button>
        </Link>
      </div>
    </>
  );
};

export default Cart;
